<script setup lang="ts">
import { faArrowLeft, faCalendar } from '@fortawesome/pro-regular-svg-icons';
import { type BillQuestion } from '@providers/support/Question/BillQuestion';

const { question } = defineProps<{
    question: BillQuestion;
}>();
const destinationName = computed(() => {
    let result = question.billInfo?.destination;
    if (question.billInfo?.hotelName) {
        result += `، ${question.billInfo?.hotelName}`;
    }
    return result;
});
</script>
<template>
    <div class="bill-question">
        <div class="service-container">
            <mr-icon
                size="small"
                :icon="question.serviceInfo.icon"
                color="var(--gray-700)"
            />
            <mr-typography size="x-small" color="var(--gray-700)">
                {{ question.serviceInfo.title }}
            </mr-typography>
        </div>
        <div class="bill-content">
            <div class="first-row">
                <div class="origin-destination">
                    <template v-if="question.billInfo?.origin">
                        <mr-typography weight="500">
                            {{ question.billInfo?.origin }}
                        </mr-typography>
                        <mr-icon size="small" :icon="faArrowLeft" />
                    </template>
                    <mr-typography weight="500">
                        {{ destinationName }}
                    </mr-typography>
                </div>
                <div
                    class="status-badge"
                    :style="{
                        backgroundColor: `var(--${question.statusInfo.color}-200)`,
                    }"
                >
                    <mr-typography
                        size="x-small"
                        weight="500"
                        :color="`var(--${question.statusInfo.color}-700)`"
                    >
                        {{ question.statusInfo.text }}
                    </mr-typography>
                </div>
            </div>
            <div class="second-row">
                <div class="date">
                    <mr-icon
                        :icon="faCalendar"
                        size="x-small"
                        color="var(--gray-700)"
                    />
                    <mr-typography size="small" weight="500">
                        {{
                            dayConfig
                                .js(question.billInfo?.departureTime)
                                .format(formatter({ separator: '/' }))
                        }}
                    </mr-typography>
                </div>
                <mr-typography size="small" color="var(--gray-700)">
                    صورت حساب: {{ question.billInfo?.billCode }}
                </mr-typography>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.bill-question {
    display: flex;
    gap: 8px;
    width: 100%;
    .service-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        padding-top: 8px;
        padding-bottom: 4px;
        width: 36px;
        border-radius: 4px;
        flex-shrink: 0;
        background-color: usePalette($p-gray, $p-100);
    }
    .bill-content {
        display: flex;
        flex-direction: column;
        gap: 4px;
        width: 100%;
        .first-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .origin-destination {
                display: flex;
                gap: 8px;
                align-items: center;
            }
            .status-badge {
                padding: 2px 4px;
                border-radius: 4px;
            }
        }
        .second-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .date {
                display: flex;
                align-items: center;
                gap: 4px;
            }
        }
    }
}
</style>
